import { Controller, useFormContext, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { SearchType } from "~/hooks/search/types";

import { InputWithClear } from "~/components/input/input-with-clear";
import { MultiTextInput } from "./multi-text-input";

interface TextInputProps {
  name: string;
  onClear: () => void;
}

export function BooksSearchInput({ name, onClear }: TextInputProps) {
  const { resetField, setFocus } = useFormContext();
  const { t } = useTranslation(["books"]);
  const typeOfSearch = useWatch({ name: "type" }) ?? SearchType.QUICK;
  const placeholder =
    typeOfSearch === SearchType.QUICK
      ? t(`books:search.placeholder.quick`)
      : t(`books:search.placeholder.semantic`);

  if (typeOfSearch === SearchType.ISBN) {
    return <MultiTextInput name={name} />;
  }

  return (
    <Controller
      name={name}
      render={({ field }) => (
        <InputWithClear
          id="search-input"
          placeholder={placeholder}
          aria-label={placeholder}
          type="text"
          autoComplete="off"
          showEnterHint
          showClearOnHover
          onClear={() => {
            resetField(name, { defaultValue: "" });
            onClear();
            setFocus(name);
          }}
          className="border-l-0 rounded-lg rounded-l-none h-full"
          {...field}
          value={field.value ?? ""}
        />
      )}
    />
  );
}
